import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
const uniqBy = require('lodash/uniqBy');
const get = require('lodash/get');
const flatMap = require('lodash/flatMap');
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const SignInStore = require('../../stores/SignInStore');
const ChannelStore = require('../../stores/channel_store_reflux');
const ChannelActions = require('../../actions/ChannelActions');
const OrganizationStore = require('../../stores/OrganizationStore');
const OrganizationActions = require('../../actions/OrganizationActions');
const ProjectStore = require('../../stores/ProjectStore');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const FeatureUtil = require('../../../../app/shared/FeatureUtil');
const SortUtil = require('../../util/SortUtil');
const FilterUtil = require('../../util/FilterUtil');
const UriUtil = require('../../util/UriUtil');
const LocalStorageUtil = require('../../util/localStorage');
const KeyboardUtil = require("../../util/keyboard");
import Navigator from '../../Navigator';
import OrganizationMemberView from '../organization/OrganizationMemberView';
import ChannelCourseStatsView from '../analytics/ChannelCourseStatsView';
import ChannelAnalyticsView from '../analytics/ChannelAnalyticsView';
import OrgAccountSettingsView from '../organization/OrgAccountSettingsView';
import OrgStudentFeedbackView from '../organization/OrgStudentFeedbackView';
import OrgProjectPermissionsView from '../organization/OrgProjectPermissionsView';
import OrgIntegrationTagsView from '../organization/OrgIntegrationTagsView';
import OrgActMetaTagsView from '../organization/OrgActMetaTagsView';
import OrgPrivacyPoliciesView from '../organization/OrgPrivacyPoliciesView';
import AccessibleIcon from '../common/AccessibleIcon';
import SortIcon from '../common/SortIcon';
import NewProjectModal from '../modal/NewProjectModal';
import NewFolderModal from '../modal/NewFolderModal';
import ProjectTileList from './ProjectTileList';
import TileListNewProject from './TileListNewProject';
import ProjectList from './ProjectList';
import ErrorBox from '../common/ErrorBox';
import FilterBox from '../common/FilterBox';
import WithOrganizationIntegrationTags from '../DataHOCs/WithOrganizationIntegrationTags';
import FolderBreadcrumbs from './FolderBreadcrumbs';
import ConfirmPhraseModal from '../modal/ConfirmPhraseModal';
import SingleInputModal from '../modal/SingleInputModal';

const propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
        search: PropTypes.string,
    }).isRequired,
    viewToken: PropTypes.oneOf(Object.values(Globals.view_tokens.author_dash.channel_views)),
    subViewToken: PropTypes.oneOf(flatMap(Globals.view_tokens.author_dash.channel_subviews, view => Object.values(view))),
    channelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    orgIntegrationTags: PropTypes.array,
};

const defaultProps = {
    orgIntegrationTags: [],
};

class ProjectsView extends React.Component {
    constructor(props) {
        super(props);

        this.getQueryObj = this.getQueryObj.bind(this);
        const queryObj = this.getQueryObj();
        const orgId = props.orgId;
        const orgStoreState = OrganizationStore.getStateOrganization(orgId);
        const accountFeatures = orgStoreState.orgAccountFeatures || null;

        this.state = {
            channelStoreStateInit: ChannelStore.getState().initialized,
            projectStoreStateInit: ProjectStore.getState().initialized,
            accountFeatures, 
            signInStoreState: SignInStore.getState(),
            modalState: {
                newProject: false,
                newFolder: false,
                deleteFolder: false,
                renameFolder: false,
            },
            sort: LocalStorageUtil.getViewSettingPropForViewSubset("channel", props.channelId, "sort") || SortUtil.getDefaultSortObjStr('name'),
            viewType: Globals.view_type.LIST,
            deleteFolderActionId: null,
            deleteFolderError: null,
            renameFolderActionId: null,
            renameFolderError: null,
        };

        this.checkToTransitionDueToStorage = this.checkToTransitionDueToStorage.bind(this);
        this.setProjectModalState = this.setProjectModalState.bind(this);
        this.setView = this.setView.bind(this);
        this.setSubView = this.setSubView.bind(this);
        this.backHandler = this.backHandler.bind(this);
        // this.setViewType = this.setViewType.bind(this);
        this.onFilterKeyDown = this.onFilterKeyDown.bind(this);
        this.onApplyFilterChange = this.onApplyFilterChange.bind(this);
        this.gotoNameFilterPath = this.gotoNameFilterPath.bind(this);
        this.onTagFilterKeyDown = this.onTagFilterKeyDown.bind(this);
        this.onApplyTagFilterChange = this.onApplyTagFilterChange.bind(this);
        this.gotoTagFilterPath = this.gotoTagFilterPath.bind(this);
        this.gotoMultiFilterPath = this.gotoMultiFilterPath.bind(this);

        this.goToOtherContentType = this.goToOtherContentType.bind(this);
        this.getContentTypeFromQuery = this.getContentTypeFromQuery.bind(this);
        this.parseContentType = this.parseContentType.bind(this);
        this.getSubViewKey = this.getSubViewKey.bind(this);

        this.goToFolderView = this.goToFolderView.bind(this);
        this.sort = this.sort.bind(this);
        this.onDeleteFolder = this.onDeleteFolder.bind(this);
        this.closeDeleteFolderError = this.closeDeleteFolderError.bind(this);

        /*  Filter performance optimizations:
                - prevent re-render when temporary filters (input element value) changes
                    ... by using uncontrolled components
                - access input values via refs passed to child
                    ... note: this breaks component encapsulation a bit
        */
        this.nameFilterInput = React.createRef();
        this.tagFilterInput = React.createRef();
        if (queryObj.nameFilter) this.manuallySetInputNameFilterValue(queryObj.nameFilter || '');
        if (queryObj.tagFilter) this.manuallySetInputTagFilterValue(queryObj.tagFilter || '');

        this.unsubscribes = [
            ChannelStore.listen(this.onChannelStoreChange.bind(this)),
            ProjectStore.listen(this.onProjectStoreChange.bind(this)),
            OrganizationStore.listen(this.onOrgStoreChange)
        ];
    }

    componentDidMount() {
        this.checkToTransitionDueToStorage();
        if (!this.state.accountFeatures) {
            let accountFeatures_actionId = uuid.v4();
            this.setState({accountFeatures_actionId},()=>{
                const orgId = this.props.orgId;
                OrganizationActions.getOrgAccountFeatures(accountFeatures_actionId, orgId);
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.checkToTransitionDueToStorage()) {
            return;
        }

        let callback = null;
        const queryObj = this.getQueryObj();
        let updatedState = {};
        if (queryObj.nameFilter !== this.getInputNameFilterValue()) {
            this.manuallySetInputNameFilterValue(queryObj.nameFilter || '');
        }

        if (queryObj.tagFilter !== this.getInputTagFilterValue()) {
            this.manuallySetInputTagFilterValue(queryObj.tagFilter || '');
        }

        if (this.props.channelId !== prevProps.channelId) {
            const orgStoreState = OrganizationStore.getStateOrganization(this.props.channelId);
            const accountFeatures = orgStoreState.orgAccountFeatures || null;
            if (accountFeatures) {
                updatedState = {
                    ...updatedState,
                    accountFeatures,
                    accountFeatures_actionId: null, // reset actionId
                };
            }
            else {
                const accountFeatures_actionId = uuid.v4();
                updatedState = {
                    ...updatedState,
                    accountFeatures_actionId, // set actionId to request accountFeatures
                    accountFeatures: null,
                }

                callback = () => { OrganizationActions.getOrgAccountFeatures(accountFeatures_actionId, this.props.channelId); }
            }

            const contentType = this.parseContentType(queryObj.cType);
            updatedState = {
                ...updatedState,
                modalState: { newProject: false, newFolder: false, deleteFolder: false, renameFolder: false, transferFolder: false },
                sort: LocalStorageUtil.getViewSettingPropForViewSubset("channel", this.getSubViewKey(contentType, this.props.channelId), "sort")
                    || SortUtil.getDefaultSortObjStr('name'),
            };
        }

        if (Object.keys(updatedState).length > 0) {
            this.setState(updatedState, () => {
                if (callback) {
                    callback();
                }
            });
        }
    }
    
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    checkToTransitionDueToStorage() {
        let willTransition = false;
        const queryObj = this.getQueryObj();
        const subViewKey = this.getSubViewKey(this.parseContentType(queryObj.cType), this.props.channelId);
        const storedNameFilter = LocalStorageUtil.getViewSettingPropForViewSubset("channel", subViewKey, "nameFilter");
        const storedTagFilter = LocalStorageUtil.getViewSettingPropForViewSubset("channel", subViewKey, "tagFilter");

        if (
            (!!storedNameFilter && storedNameFilter !== queryObj.nameFilter)
            || (!!storedTagFilter && storedTagFilter !== queryObj.tagFilter)
        ) {
            this.gotoMultiFilterPath(storedNameFilter, storedTagFilter);
            willTransition = true;
        }

        return willTransition;
    }

    onChannelStoreChange(state) {
        let additionalState = {};
        if (state.action && state.action.id === this.state.renameFolderActionId) {
            additionalState = {
                ...additionalState,
                renameFolderActionId: null,
                renameFolderError: state.action.error || null,
                modalState: { ...this.state.modalState, renameFolder: !!state.action.error ? true : false },
            };
        }

        if (state.action && state.action.id === this.state.deleteFolderActionId) {
            additionalState = {
                ...additionalState,
                deleteFolderActionId: null,
                deleteFolderError: state.action.error || null,
            };
        }

        this.setState({ channelStoreStateInit: state.initialized, ...additionalState });
    }

    onProjectStoreChange(state) {
        this.setState({ projectStoreStateInit: state.initialized });
    }

    onOrgStoreChange=(state)=>{
        const orgId = this.props.channelId;
        if (state.action.id === this.state.accountFeatures_actionId) {
            const orgStoreState = OrganizationStore.getStateOrganization(orgId);
            const accountFeatures = orgStoreState.orgAccountFeatures || {};
            if (state.action.error) {
                console.log("error getting org account features",state.action.error);
            }
            this.setState({accountFeatures, accountFeatures_actionId: null});
        }
    }

    setProjectModalState(showBool) {
        this.setState({ modalState: { ...this.state.modalState, newProject: showBool } })
    }

    setFolderModalState(showBool) {
        this.setState({ modalState: { ...this.state.modalState, newFolder: showBool } })
    }

    setDeleteFolderModalState(showBool) {
        this.setState({ modalState: { ...this.state.modalState, deleteFolder: showBool } })
    }

    setRenameFolderModalState(showBool) {
        this.setState({ modalState: { ...this.state.modalState, renameFolder: showBool } })
    }

    // set subview (Manage Org Members, Analytics, etc)
    setView(viewToken) {
        if (Object.values(Globals.view_tokens.author_dash.channel_views).indexOf(viewToken) < 0) return;

        Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, this.props.channelId, viewToken);
    }

    setSubView(viewToken, subViewToken) {
        if (Object.values(Globals.view_tokens.author_dash.channel_views).indexOf(viewToken) < 0){
            return;
        } 

        if (
            !Globals.view_tokens.author_dash.channel_subviews[viewToken]
            || Object.values(Globals.view_tokens.author_dash.channel_subviews[viewToken]).indexOf(subViewToken) < 0
        ) {
            return;
        }

        Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, this.props.channelId, viewToken, { channelSubView: subViewToken });
    }

    // go back from subview
    backHandler() {
        if (!this.props.viewToken) return;

        Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, this.props.channelId);
    }

    getInputNameFilterValue() {
        const inputVal = get(this.nameFilterInput, 'current.value', null);
        if (typeof inputVal === 'string') {
            return inputVal;
        }
        else {
            return '';
        }
    }

    manuallySetInputNameFilterValue(value) {
        if (this.nameFilterInput && this.nameFilterInput.current) {
            this.nameFilterInput.current.value = value;
        }
    }

    getInputTagFilterValue() {
        const inputVal = get(this.tagFilterInput, 'current.value', null);
        if (typeof inputVal === 'string') {
            return inputVal;
        }
        else {
            return '';
        }
    }

    manuallySetInputTagFilterValue(value) {
        if (this.tagFilterInput.current) {
            this.tagFilterInput.current.value = value;
        }
    }

    // set 'tile' vs 'list', store in LocalStorage if available
    /*setViewType(viewType) {
        LocalStorageUtil.setViewSettingPropForView('channel', 'view_type', viewType);
        this.setState({ viewType: viewType });
    }*/

    onFilterKeyDown(e) {
        if (KeyboardUtil.isEnterKey(e.keyCode)) this.onApplyFilterChange();
    }

    onApplyFilterChange() {
        const inputFilterNameValue = this.getInputNameFilterValue();
        const subViewKey = this.getSubViewKey(this.getContentTypeFromQuery(), this.props.channelId);
        LocalStorageUtil.setViewSettingPropForViewSubset('channel', subViewKey, 'nameFilter', inputFilterNameValue);
        this.gotoNameFilterPath(inputFilterNameValue);
    }

    gotoNameFilterPath(nameFilter) {
        const queryObj = this.getQueryObj();
        let query = {};
        if (!!nameFilter) query.nameFilter = nameFilter;
        if (!!queryObj.tagFilter) query.tagFilter = queryObj.tagFilter;
        if (!!queryObj.fId) query.fId = queryObj.fId;
        if (!!queryObj.cType) query.cType = queryObj.cType;

        Navigator.addQueryToCurrentPath(
            this.props.history,
            this.props.location,
            {
                replace: true,
                queryObj: query,
                addLeadingQuestionMark: true,
            }
        );
    }

    onTagFilterKeyDown(e) {
        if (KeyboardUtil.isEnterKey(e.keyCode)) this.onApplyTagFilterChange();
    }

    onApplyTagFilterChange() {
        const inputTagFilterValue = this.getInputTagFilterValue();
        const subViewKey = this.getSubViewKey(this.getContentTypeFromQuery(), this.props.channelId);
        LocalStorageUtil.setViewSettingPropForViewSubset('channel', subViewKey, 'tagFilter', inputTagFilterValue);
        this.gotoTagFilterPath(inputTagFilterValue);
    }

    gotoTagFilterPath(tagFilter) {
        const queryObj = this.getQueryObj();
        let query = {};
        if (!!tagFilter) query.tagFilter = tagFilter;
        if (!!queryObj.nameFilter) query.nameFilter = queryObj.nameFilter;
        if (!!queryObj.fId) query.fId = queryObj.fId;
        if (!!queryObj.cType) query.cType = queryObj.cType;

        Navigator.addQueryToCurrentPath(
            this.props.history,
            this.props.location,
            {
                replace: true,
                queryObj: query,
                addLeadingQuestionMark: true,
            }
        );
    }

    gotoMultiFilterPath(nameFilter, tagFilter) {
        const queryObj = this.getQueryObj();
        let query = {};
        if (!!nameFilter) query.nameFilter = nameFilter;
        if (!!tagFilter) query.tagFilter = tagFilter;
        if (!!queryObj.fId) query.fId = queryObj.fId;
        if (!!queryObj.cType) query.cType = queryObj.cType;

        Navigator.addQueryToCurrentPath(
            this.props.history,
            this.props.location,
            {
                replace: true,
                queryObj: query,
                addLeadingQuestionMark: true,
            }
        );
    }

    goToFolderView(fId=null) {
        const queryObj = this.getQueryObj();
        let query = {};
        if (!!queryObj.nameFilter) query.nameFilter = queryObj.nameFilter;
        if (!!queryObj.tagFilter) query.tagFilter = queryObj.tagFilter;
        if (!!queryObj.cType) query.cType = queryObj.cType;
        if (!!fId) query.fId = fId;  // fId = null goes back from folder view

        Navigator.goToDashboardAuthorAuthoringChannelView(
            this.props.history,
            this.props.channelId,
            (fId === null ? null : 'folder'),
            {
                queryObj: query,
                addLeadingQuestionMark: true,
            }
        );
    }

    goToOtherContentType(contentType) {
        Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, this.props.channelId, null, { queryObj: { cType: contentType }, addLeadingQuestionMark: true });
    }

    sort(contentType, key, type) {
        const newSortObj = SortUtil.updateSortObj(this.state.sort, key, type);
        LocalStorageUtil.setViewSettingPropForViewSubset('channel', this.getSubViewKey(contentType, this.props.channelId), 'sort', newSortObj);
        this.setState({ sort: newSortObj });
    }

    getSubViewKey(contentType, channelId) {
        if (contentType === Globals.content_type.ACTIVITY) {
            return this.props.channelId;
        }
        else if (contentType === Globals.content_type.COURSE) {
            return `${channelId}_course`;
        }
    }

    getQueryObj() {
        return UriUtil.parseLocationSearchString(this.props.location);
    }

    getContentTypeFromQuery() {
        return this.parseContentType(this.getQueryObj().cType);
    }

    parseContentType(cType) {
        if (!cType || cType === Globals.content_type.ACTIVITY) {
            return Globals.content_type.ACTIVITY;
        }
        else if (cType === Globals.content_type.COURSE) {
            return Globals.content_type.COURSE;
        }
        else {
            console.warn("Invalid content type. Returning 'activity'");
            return Globals.content_type.ACTIVITY;
        }  
    }

    onDeleteFolder(folderIdObj) {
        const deleteFolderActionId = uuid.v4();
        this.setState({ deleteFolderActionId: deleteFolderActionId,  modalState: { ...this.state.modalState, deleteFolder: false } }, () => {
            this.goToFolderView(folderIdObj.parentId);
            ChannelActions.deleteFolder(deleteFolderActionId, { folderId: folderIdObj.folderId, channelId: this.props.channelId });
        });
    }

    onRenameFolder(folderId, name) {
        const renameFolderActionId = uuid.v4();
        this.setState({ renameFolderActionId: renameFolderActionId }, () => {
            ChannelActions.renameFolder(renameFolderActionId, { folderId: folderId, name: name});
        });
    }

    closeDeleteFolderError() {
        this.setState({ deleteFolderError: null });
    }

    render() {
        if (!this.state.channelStoreStateInit || !this.state.projectStoreStateInit || !this.state.accountFeatures) {
            return null;
        }

        const channelStoreState = ChannelStore.getStateChannel(this.props.channelId);
        const projectStoreState = ProjectStore.getStateChannel(this.props.channelId);
        const channel = channelStoreState.channel;
        let projects; // can be changed, see uniq comment below
        let folders;
        let foldersFlat;
        const contentType = this.getContentTypeFromQuery();
        if (contentType === Globals.content_type.ACTIVITY) {
            projects = projectStoreState.projects;
            folders = channelStoreState.folders;
            foldersFlat = channelStoreState.foldersFlat;
        }
        else if (contentType === Globals.content_type.COURSE) {
            projects = projectStoreState.shortCourseProjects;
            folders = channelStoreState.shortCourseFolders;
            foldersFlat = channelStoreState.shortCourseFoldersFlat;
        }
        else {
            console.error('Unknown content type');
            return null;
        }

        if (!channel || !projects) {
            console.error('No channel or projects found');
            console.log('Channel:', channel);
            console.log('Projects:', projects);
            return null;
        }

        const self = this;
        const canViewOrgMembers = PermissionsUtil.canViewOrgMembers(channel.user_permissions);
        const canMangeProjectPermissions = PermissionsUtil.canEditProjectCollaborators(channel.user_permissions, {})
            && channel.user_permissions.manageLevel;
        const canManageTags = PermissionsUtil.canManageProjectTags(channel.user_permissions)
            && FeatureUtil.hasIntegrationTags(channel.channel_permissions);
        const canManageActMetaTags = PermissionsUtil.canManageActMetaTags(channel.user_permissions)
            && FeatureUtil.hasActivityMetaTags(channel.channel_permissions);
        const canViewPrivacyPolicies = PermissionsUtil.canViewPrivacyPolicies(channel.user_permissions)
            && FeatureUtil.hasPrivacyPolicies(channel.channel_permissions);
        const canViewCourseStats = Globals.users.is_org_account_type(channel.channel_account_type_token)
             && PermissionsUtil.viewDetailedChannelAnalytics(channel.user_permissions)
             && FeatureUtil.hasDetailedAnalytics(channel.channel_permissions);
        const canViewStudentFeedback = PermissionsUtil.canEditProjectCollaborators(channel.user_permissions, {})
            && channel.user_permissions.manageLevel;

        const accountHasAnalytics = FeatureUtil.hasDetailedAnalytics(channel.channel_permissions);
        const userCanViewAnalytics = PermissionsUtil.viewDetailedChannelAnalytics(channel.user_permissions);
        const canViewAnalytics = accountHasAnalytics && userCanViewAnalytics;
        const canViewOrgAccountSettings = PermissionsUtil.canDoOrgActions(channel.user_permissions);

        const queryStringObj = this.getQueryObj();
        const nameFilter = queryStringObj.nameFilter || '';
        const tagFilter = canManageTags ? queryStringObj.tagFilter || '' : '';

        if (this.props.viewToken === 'orgMembers' && canViewOrgMembers) {
            return (
                <OrganizationMemberView
                    orgId={this.props.channelId}
                    backHandler={this.backHandler}
                    heading={channel.name}
                    userPermissions={channel.user_permissions}
                />
            );
        }
        
        if (this.props.viewToken === Globals.view_tokens.author_dash.channel_views.COURSE_STATS && canViewCourseStats) {
            return (
                <ChannelCourseStatsView
                    channelId={this.props.channelId}
                    backHandler={this.backHandler}
                    heading={channel.name + " - New Student Statistics"}
                    orgName={channel.name}
                    subViewToken={this.props.subViewToken}
                    onChangeSubView={this.setSubView.bind(this, Globals.view_tokens.author_dash.channel_views.COURSE_STATS)}
                />
            );
        }

        if (this.props.viewToken === 'studentFeedback' && canViewStudentFeedback) {
            return (
                <OrgStudentFeedbackView
                    history={this.props.history}
                    orgId={this.props.channelId}
                    backHandler={this.backHandler}
                    orgName={channel.name}
                />
            );
        }

        if (this.props.viewToken === 'analytics' && canViewAnalytics) {
            return (
                <ChannelAnalyticsView
                    channelId={this.props.channelId}
                    backHandler={this.backHandler}
                    heading={channel.name + " - Channel Analytics"}
                    userPermissions={channel.user_permissions}
                    channelPermissions={channel.channel_permissions}
                    channelCreateDate={channel.created_at}
                />
            );
        }

        if (this.props.viewToken === 'orgAccountSettings' && canViewOrgAccountSettings) {
            return (
                <OrgAccountSettingsView
                    orgId={this.props.channelId}
                    backHandler={this.backHandler}
                    heading={channel.name}
                    permissions={channel.user_permissions}
                />
            );
        }

        if (this.props.viewToken === 'orgProjectPermissions' && canMangeProjectPermissions) {
            return (
                <OrgProjectPermissionsView
                    orgId={this.props.channelId}
                    backHandler={this.backHandler}
                    heading="Manage Project Collaborators"
                    permissions={channel.user_permissions}
                />
            );
        }

        if (this.props.viewToken === 'orgIntegrationTags' && canManageTags) {
            return (
                <OrgIntegrationTagsView
                    orgId={this.props.channelId}
                    channelId={this.props.channelId}
                    backHandler={this.backHandler}
                    heading="Manage Integration Tags"
                    permissions={channel.user_permissions}
                />
            );
        }

        if (this.props.viewToken === 'orgActMetaTags' && canManageActMetaTags) {
            return (
                <OrgActMetaTagsView
                    orgId={this.props.channelId}
                    channelId={this.props.channelId}
                    backHandler={this.backHandler}
                    heading="Manage Activity Meta Tags"
                    permissions={channel.user_permissions}
                />
            );
        }

        if (this.props.viewToken === 'orgPrivacyPolicies' && canViewPrivacyPolicies) {
            return (
                <OrgPrivacyPoliciesView
                    orgId={this.props.channelId}
                    backHandler={this.backHandler}
                    heading={Strings['en'].privacy_policy.MANAGE_PP}
                    channelPermissions={channel.channel_permissions}
                    userPermissions={channel.user_permissions}
                />
            );
        }

        let viewFolderId = null;
        let viewFolder = null;
        let parentFolder = null;
        let grandParentFolder = null;
        let foldersAtViewLevel = folders;
        if (this.props.viewToken === 'folder') {
            const queryObj = this.getQueryObj();
            if (!queryObj.fId) {
                console.warn('Folder view missing fId');
            }
            else {
                viewFolder = foldersFlat[queryObj.fId]
                if (!viewFolder) {
                    console.error(`ViewFolder fId ${queryObj.fId} not found`)
                }
                else {
                    if (viewFolder.gp_id) {
                        foldersAtViewLevel = {};
                        grandParentFolder = folders[viewFolder.gp_id];
                        parentFolder = folders[viewFolder.gp_id].children[viewFolder.parent_id]
                    }
                    else if (viewFolder.parent_id) {
                        foldersAtViewLevel = folders[viewFolder.parent_id].children[viewFolder.id].children;
                        parentFolder = folders[viewFolder.parent_id];
                    }
                    else {
                        foldersAtViewLevel = folders[viewFolder.id].children;
                    }
                }
            }
        }

        // FIXME: GET Projects API will return duplicate projects when the requesting user has both channel level permissions (CHANNEL_OWNER, ORG_OWNER, ORG_ADMIN)
        // ...and has been added as a collab to the project. since project permissions do not matter in this context, we can filter out duplicates without issue.
        projects = uniqBy(projects, project => { return project.id });
        const sortedProjects = SortUtil.sortObjectArray(projects, this.state.sort);
        const sortedFolders = SortUtil.sortObjectArray(foldersAtViewLevel, this.state.sort);

        const createProjectButton = (
            PermissionsUtil.canCreateProject(channel.user_permissions) ?
                <li>
                    <button
                        className="btn btn-primary glyph btn-circle btn-lg"
                        onClick={this.setProjectModalState.bind(this, true)}
                        title="Add project into the currently selected hierarchy"
                    >
                        <AccessibleIcon label="Add project">
                            <span className="fa fa-plus margin-right-sm" aria-hidden="true" />
                            <span className="fa fa-lightbulb-o" aria-hidden="true" />
                        </AccessibleIcon>
                    </button>
                </li>
                :
                null
        );

        const createFolderButton = (
            PermissionsUtil.canCreateFolder(channel.user_permissions) && !grandParentFolder ?
                <li>
                    <button
                        className="btn btn-primary glyph btn-circle btn-lg"
                        onClick={this.setFolderModalState.bind(this, true)}
                        title="Add folder into the currently selected hierarchy"
                    >
                        <AccessibleIcon label="Add folder">
                            <span className="fa fa-plus margin-right-sm" aria-hidden="true" />
                            <span className="fa fa-folder" aria-hidden="true" />
                        </AccessibleIcon>
                    </button>
                </li>
                :
                null
        );

        const deleteFolderButton = (
            PermissionsUtil.canDeleteFolder(channel.user_permissions) && !!viewFolder ?
                <li>
                    <button
                        className="btn btn-primary glyph btn-circle btn-lg"
                        onClick={this.setDeleteFolderModalState.bind(this, true)}
                        title="Delete Folder"
                    >
                        <AccessibleIcon label="Remove folder">
                            <span className="fa fa-folder margin-right-sm" aria-hidden="true" />
                            <span className="fa fa-remove" aria-hidden="true" />
                        </AccessibleIcon>
                    </button>
                </li>
                :
                null
        );

        const renameFolderButton = (
            PermissionsUtil.canCreateFolder(channel.user_permissions) && !!viewFolder ?
                <li>
                    <button
                        className="btn btn-primary glyph btn-circle btn-lg"
                        onClick={this.setRenameFolderModalState.bind(this, true)}
                        title="Rename Folder"
                    >
                        <AccessibleIcon label="Rename folder">
                            <span className="fa fa-folder margin-right-sm" aria-hidden="true" />
                            <span className="fa fa-pencil" aria-hidden="true" />
                        </AccessibleIcon>
                    </button>
                </li>
                :
                null
        );

        let otherContentTypeToken;
        let otherContentButtonLabel;
        let otherContentButtonIconClass;
        let showContentSwapButton = this.state.signInStoreState && this.state.signInStoreState.userInfo && this.state.signInStoreState.userInfo.admin;
        if (!showContentSwapButton) {
            if (this.state.accountFeatures[Globals.users.account_features.shortCourseAuthoring]) {
                showContentSwapButton = true;
            }
        }
        
        
        if (contentType === Globals.content_type.ACTIVITY) {
            otherContentTypeToken = Globals.content_type.COURSE;
            otherContentButtonLabel = 'Go to short courses';
            otherContentButtonIconClass = 'fa fa-certificate';
        }
        else {
            otherContentTypeToken = Globals.content_type.ACTIVITY
            otherContentButtonLabel = 'Go to activities';
            otherContentButtonIconClass = 'fa fa-pencil';
        }

        const swapContentTypeButton = showContentSwapButton ? (
            <li>
                <button
                    className="btn btn-primary glyph btn-circle btn-lg margin-right-xl"
                    onClick={this.goToOtherContentType.bind(this, otherContentTypeToken)}
                    title={otherContentButtonLabel}
                >
                    <AccessibleIcon label={otherContentButtonLabel}>
                        <span className={`${otherContentButtonIconClass}`} aria-hidden="true" />
                    </AccessibleIcon>
                </button>
            </li>
        ) : null;

        const orgMemberButton = (
            canViewOrgMembers ?
                <li>
                    <button
                        className="btn btn-primary glyph btn-circle btn-lg"
                        onClick={this.setView.bind(this, 'orgMembers')}
                        title="Edit Organization Members"
                    >
                        <AccessibleIcon label="Users">
                            <span className="fa fa-users" aria-hidden={true}/>
                        </AccessibleIcon>
                    </button>
                </li>
                :
                null
        );

        const orgProjectPermissionsButton = (
            canMangeProjectPermissions ?
                <li>
                    <button
                        className="btn btn-primary glyph btn-circle btn-lg"
                        onClick={this.setView.bind(this, 'orgProjectPermissions')}
                        title="Manage Project Collaborators"
                    >
                        <AccessibleIcon label="Manage Project Collaborators">
                            <span className="fa fa-lightbulb-o" aria-hidden="true"/>
                        </AccessibleIcon>
                    </button>
                </li>
                :
                null
        );

        const orgIntegrationTagsButton = (
            canManageTags ?
                <li>
                    <button
                        className="btn btn-primary glyph btn-circle btn-lg"
                        onClick={this.setView.bind(this, 'orgIntegrationTags')}
                        title="Manage Integration Tags"
                    >
                        <AccessibleIcon label="Manage Integration Tags">
                          <span className="fa fa-tags" aria-hidden="true"/>
                        </AccessibleIcon>
                    </button>
                </li>
                :
                null
        );

        const orgActMetaTagsButton = (
            canManageActMetaTags ?
                <li>
                    <button
                        className="btn btn-primary glyph btn-circle btn-lg"
                        onClick={this.setView.bind(this, 'orgActMetaTags')}
                        title="Manage Activity Meta Tags"
                    >
                        <AccessibleIcon label="Manage Activity Meta Tags">
                          <span className="fa fa-tag" aria-hidden="true"/>
                        </AccessibleIcon>
                    </button>
                </li>
                :
                null
        );

        const orgPrivacyPoliciesButton = (
            canViewPrivacyPolicies ?
                <li>
                    <button
                        className="btn btn-primary glyph btn-circle btn-lg"
                        onClick={this.setView.bind(this, 'orgPrivacyPolicies')}
                        title="Manage Privacy Policies"
                    >
                        <AccessibleIcon label="Manage Privacy Policies">
                          <span className="fa fa-id-card-o" aria-hidden="true"/>
                        </AccessibleIcon>
                    </button>
                </li>
                :
                null
        );

        let analyticsButtonTooltip = 'View Analytics';
        let analyticsButtonDisabled = false;
        if (!accountHasAnalytics) { // notify user of upgrade requirement if their role allows viewing, but account does not include detailed analytics
            analyticsButtonTooltip += ' (upgrade to access this feature)';
            analyticsButtonDisabled = true;
        }

        const analyticsButton = (
            userCanViewAnalytics ? //obscure button entirely if user does not have permission to view analytics
                <li>
                    <button
                        disabled={analyticsButtonDisabled}
                        className={"btn btn-primary glyph btn-circle btn-lg"}
                        onClick={this.setView.bind(this, 'analytics')}
                        title={analyticsButtonTooltip}
                    >
                        <AccessibleIcon
                        label="Users">
                            <span className="fa fa-bar-chart" aria-hidden={true}/>
                        </AccessibleIcon>
                    </button>
                </li>
                :
                null
        );

        const courseStatsButton = (
            canViewCourseStats ? 
                <li>
                    <button
                        disabled={false}
                        className={"btn btn-primary glyph btn-circle btn-lg"}
                        onClick={this.setView.bind(this, 'courseStats')}
                        title={'View New Student Statistics'}
                    >
                        <AccessibleIcon label="New Student Statistics">
                            <span className="fa fa-university" aria-hidden={true}/>
                        </AccessibleIcon>
                    </button>
                </li>
                :
                null
        );

        const studentFeedbackButton = (
            canViewStudentFeedback ? 
                <li>
                    <button
                        disabled={false}
                        className={"btn btn-primary glyph btn-circle btn-lg"}
                        onClick={this.setView.bind(this, 'studentFeedback')}
                        title={'View Student Feedback'}
                    >
                        <AccessibleIcon label="Student Feedback">
                            <span className="fa fa-comments-o" aria-hidden={true}/>
                        </AccessibleIcon>
                    </button>
                </li>
                :
                null
        );
        
        
        const orgAccountSettingsButton = (
            canViewOrgAccountSettings ?
                <li>
                    <button
                        className="btn btn-primary glyph btn-circle btn-lg"
                        onClick={this.setView.bind(this, 'orgAccountSettings')}
                        title="View Organization Settings"
                    >
                        <AccessibleIcon label="Settings">
                            <span className="fa fa-cog" aria-hidden={true}/>
                        </AccessibleIcon>
                    </button>
                </li>
                :
                null
        );

        // optimization: see FilterUtil.getTagsWithMatchingDescObj() comment
        const tagsWithMatchingDesc = FilterUtil.getTagsWithMatchingDescObj(tagFilter, this.props.orgIntegrationTags);

        return (
            <div>
                <ErrorBox error={channelStoreState.error}/>
                <ErrorBox error={projectStoreState.error}/>

                <div className="channelHeadingFlex">
                    <div className="channelHeadingFlex__heading">
                        <h2 className="heading-lg">{channel.name}</h2>
                    </div>
                    <ul className="inline-list channelHeadingFlex__rightControl">
                        {orgMemberButton}
                        {orgProjectPermissionsButton}
                        {orgIntegrationTagsButton}
                        {orgActMetaTagsButton}
                        {orgPrivacyPoliciesButton}
                        {analyticsButton}
                        {courseStatsButton}
                        {studentFeedbackButton}
                        {orgAccountSettingsButton}
                        {/* this.state.viewType === Globals.view_type.TILE ?
                            <li>
                                <button
                                className="btn btn-default glyph btn-circle btn-lg no-pad btn-toggle"
                                onClick={this.setViewType.bind(this, Globals.view_type.LIST)}
                                title="List view">
                                    <span className="fa fa-list" aria-hidden={true}/>
                                </button>
                            </li>
                            :
                            <li>
                                <button
                                className="btn btn-default glyph btn-circle btn-lg no-pad btn-toggle"
                                onClick={this.setViewType.bind(this, Globals.view_type.TILE)}
                                title="Tile view">
                                    <span className="fa fa-th-large" aria-hidden={true}/>
                                </button>
                            </li>
                        */}
                    </ul>
                    <div className="float-clear-r"/>
                </div>
                <div className="channelHeadingFlex">
                    <div className="channelHeadingFlex__heading--wrap">
                        <div className="inline-block margin-right-md">
                            <FilterBox
                                className="padding-tb-md"
                                inputId="proj-name-filter"
                                icon="fa fa-font"
                                label="Filter By Name"
                                onKeyDown={this.onFilterKeyDown}
                                inputRef={this.nameFilterInput}
                            >
                                <button
                                    className="bare-text-button glyph margin-left-md margin-right-md"
                                    onClick={this.onApplyFilterChange}
                                    onKeyDown={this.onFilterKeyDown}
                                >
                                    <i className="fa fa-search" aria-hidden />
                                    <span className="sr-only">Filter</span>
                                </button>
                            </FilterBox>
                        </div>
                        {canManageTags &&
                            <div className="inline-block">
                                <FilterBox
                                    className="padding-tb-md"
                                    inputId="proj-tag-filter"
                                    icon="fa fa-tags"
                                    label="Filter By Tag"
                                    onKeyDown={this.onTagFilterKeyDown}
                                    inputRef={this.tagFilterInput}
                                >
                                    <button
                                        className="bare-text-button glyph margin-left-md margin-right-md"
                                        onClick={this.onApplyTagFilterChange}
                                        onKeyDown={this.onTagFilterKeyDown}
                                    >
                                        <i className="fa fa-search" aria-hidden />
                                        <span className="sr-only">Filter</span>
                                    </button>
                                </FilterBox>
                            </div>
                        }
                    </div>
                    <ul className="inline-list channelHeadingFlex__rightControl">
                        {/* this.state.viewType === Globals.view_type.TILE ? // only show sort buttons for tile view
                            <li>
                                <button
                                className={SortUtil.sortObjUsesKey(this.state.sort, 'name') ? "btn btn-default glyph btn-circle btn-lg no-pad btn-toggle selected" : "btn btn-default glyph btn-circle btn-lg no-pad btn-toggle" }
                                onClick={this.sort.bind(this, 'name', Globals.sort.type.STRING)}
                                title="Sort by name">
                                    <SortIcon
                                    asc={(this.state.sort.key === 'name' && this.state.sort.asc) || this.state.sort.key !== 'name'}
                                    label="Alphabetic">
                                        <span className="fa fa-sort-alpha-asc" aria-hidden="true"/>
                                    </SortIcon>
                                </button>
                            </li>
                            :
                            null
                        */}
                        {/* this.state.viewType === Globals.view_type.TILE ? // only show sort buttons for tile view
                            <li>
                                <button
                                className={SortUtil.sortObjUsesKey(this.state.sort, 'created_at') ? "btn btn-default glyph btn-circle btn-lg no-pad btn-toggle selected" : "btn btn-default glyph btn-circle btn-lg no-pad btn-toggle" }
                                onClick={this.sort.bind(this, 'created_at', Globals.sort.type.DATE)}
                                title="Sort by create date">
                                    <SortIcon
                                    asc={(this.state.sort.key === 'created_at' && this.state.sort.asc) || this.state.sort.key !== 'created_at'}
                                    label="Create date">
                                        <span className="fa fa-calendar" aria-hidden="true"/>
                                    </SortIcon>
                                </button>
                            </li>
                            :
                            null
                        */}
                        {/* this.state.viewType === Globals.view_type.TILE ? // only show sort buttons for tile view
                            <li>
                                <button
                                className={SortUtil.sortObjUsesKey(this.state.sort, 'modified') ? "btn btn-default glyph btn-circle btn-lg no-pad btn-toggle selected" : "btn btn-default glyph btn-circle btn-lg no-pad btn-toggle" }
                                onClick={this.sort.bind(this, 'modified', Globals.sort.type.DATE)}
                                title="Sort by modified date">
                                    <SortIcon
                                    asc={(this.state.sort.key === 'modified' && this.state.sort.asc) || this.state.sort.key !== 'modified'}
                                    label="Create date">
                                        <span className="fa fa-pencil-square-o" aria-hidden="true"/>
                                    </SortIcon>
                                </button>
                            </li>
                            :
                            null
                        */}
                        {swapContentTypeButton}
                        {createFolderButton}
                        {deleteFolderButton}
                        {renameFolderButton}
                        {createProjectButton}
                    </ul>
                </div>
                <FolderBreadcrumbs
                    className="margin-top-md margin-bottom-md"
                    showNav={!!viewFolder}
                    rootName={channel.name}
                    goToFolderView={this.goToFolderView}
                    currentFolder={viewFolder}
                    parentFolder={parentFolder}
                    grandParentFolder={grandParentFolder}
                />
                {/*<div className="projectsStatusBox margin-top-lg margin-bottom-md">
                    <span>{sortedProjects.length} Project{sortedProjects.length !== 1 ? 's' : ''}</span>
                </div>*/}
                <ErrorBox error={this.state.deleteFolderError} onClose={this.closeDeleteFolderError} />
                
                { sortedProjects.length > 0 || sortedFolders.length > 0 ?
                    this.state.viewType == Globals.view_type.TILE ?
                        <ProjectTileList
                            projects={sortedProjects}
                            folders={sortedFolders}
                            projectMatchesFilter={FilterUtil.projectMatchesFilter.bind(this, nameFilter, tagFilter, tagsWithMatchingDesc)}
                            folderMatchesFilter={FilterUtil.folderMatchesFilter.bind(this, nameFilter, tagFilter)}
                            filterActive={!!nameFilter || !!tagFilter}
                            goToFolderView={this.goToFolderView}
                            rootName={channel.name}
                            viewFolder={viewFolder}
                            parentFolder={parentFolder}
                            grandParentFolder={grandParentFolder}
                        />
                        :
                        <ProjectList
                            channelId={channel.id}
                            projects={sortedProjects}
                            folders={sortedFolders}
                            foldersFlat={foldersFlat}
                            sortObj={this.state.sort}
                            sortFunc={this.sort.bind(this, contentType)}
                            projectMatchesFilter={FilterUtil.projectMatchesFilter.bind(this, nameFilter, tagFilter, tagsWithMatchingDesc)}
                            activityMatchesFilter={FilterUtil.activityMatchesFilter.bind(this, nameFilter, tagFilter, tagsWithMatchingDesc)}
                            shortCourseMatchesFilter={FilterUtil.shortCourseMatchesFilter.bind(this, nameFilter, tagFilter, tagsWithMatchingDesc)}
                            folderMatchesFilter={FilterUtil.folderMatchesFilter.bind(this, nameFilter, tagFilter)}
                            filterActive={!!nameFilter || !!tagFilter}
                            goToFolderView={this.goToFolderView}
                            viewFolder={viewFolder}
                            parentFolder={parentFolder}
                            grandParentFolder={grandParentFolder}
                            contentType={contentType}
                        />
                    :
                    PermissionsUtil.canCreateProject(channel.user_permissions) && !nameFilter && !tagFilter ?
                        this.state.viewType == Globals.view_type.TILE ?
                            <TileListNewProject createProjectFunc={this.setProjectModalState.bind(self, true)} />
                            : /* TODO: need list format add project prompt */
                            <TileListNewProject createProjectFunc={this.setProjectModalState.bind(self, true)} />
                        :
                        <h3 className="heading-lg text-centered">No Projects</h3>
                }

                { this.state.modalState['newProject'] &&
                    <NewProjectModal
                        show
                        closeHandler={this.setProjectModalState.bind(this, false)}
                        channelId={this.props.channelId}
                        channelName={channel.name}
                        folderId={!!viewFolder ? viewFolder.id : ''}
                        folderName={!!viewFolder ? viewFolder.name : ''}
                        contentType={contentType}
                    />
                }
                { this.state.modalState['newFolder'] &&
                    <NewFolderModal
                        show
                        closeHandler={this.setFolderModalState.bind(this, false)}
                        channelId={this.props.channelId}
                        channelName={channel.name}
                        folderId={!!viewFolder ? viewFolder.id : ''}
                        folderName={!!viewFolder ? viewFolder.name : ''}
                        contentType={contentType}
                    />
                }
                { this.state.modalState['deleteFolder'] &&
                    <ConfirmPhraseModal
                        show
                        closeHandler={this.setDeleteFolderModalState.bind(this, false)}
                        cancelHandler={this.setDeleteFolderModalState.bind(this, false)}
                        confirmButtonBsStyle="danger"
                        confirmPhrase="delete"
                        confirmHandler={this.onDeleteFolder}
                        confirmData={{folderId: viewFolder.id, parentId: !!parentFolder ? parentFolder.id : null }}
                        cancelButtonText="cancel"
                    >
                        <div className="margin-bottom-lg">
                            <p>Are you sure you wish to delete <em className="font-style-italic">{viewFolder.name}</em>?</p>
                            <p>This will delete <em className="font-style-italic">all folders, projects and activities</em> in this folder.</p>
                        </div>
                    </ConfirmPhraseModal>
                }
                { this.state.modalState['renameFolder'] &&
                    <SingleInputModal
                        show
                        error={this.state.renameFolderError}
                        disableButton={!!this.state.renameFolderActionId}
                        headerText="Rename Folder"
                        inputLabel="new name"
                        ariaLabel="new name"
                        buttonText="confirm"
                        defaultValue={viewFolder.name}
                        closeHandler={this.setRenameFolderModalState.bind(this, false)}
                        submitHandler={this.onRenameFolder.bind(this, viewFolder.id)}
                    />
                }
            </div>
        );
    }
}

ProjectsView.propTypes = propTypes;
ProjectsView.defaultProps = defaultProps;

export default withRouter(WithOrganizationIntegrationTags(ProjectsView));
